/**
 * ============================================================
 * ABAYA LUXURY — Custom JavaScript
 * Scroll animations · Header behaviour · UX enhancements
 * ============================================================
 */

(function () {
  'use strict';

  /* ── 1. (removed) SCROLL-REVEAL OBSERVER ──────────────────────
     Removed 2026-08. Scroll reveal now lives in
     assets/abaya-motion.js. Three faults made this version worth
     replacing outright rather than patching:

     1. It injected
          .is-visible { opacity:1 !important; transform: translateY(0) !important }
        which beat `.card:hover { transform: translateY(-3px) }`.
        Every card that had scrolled into view — all of them, since
        revealing requires scrolling — permanently lost its hover
        lift. Reproduced in Chromium before removing:
          before injection  .card.is-visible hover → matrix(1,0,0,1,0,-3)
          after  injection  .card.is-visible hover → matrix(1,0,0,1,0, 0)

     2. The stagger was `index * 60ms` across the WHOLE page, so on
        a ~30-element homepage the last item waited ~1.9s after
        entering the viewport before moving.

     3. Writing inline styles bypassed the
        `prefers-reduced-motion` guard in the stylesheet.

     Also dropped with it: a listener for an 'abaya:visible' event
     nothing ever dispatched, and `addEventListener('is-visible',…)`
     — a class name is not an event type, so it could never fire.
  ──────────────────────────────────────────────────────────── */

  /* ── 2. STICKY HEADER WITH SCROLL DIRECTION ───────────────── */
  function initStickyHeader() {
    var header = document.querySelector('.header');
    if (!header) return;

    var lastScrollY = window.scrollY;
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var currentScrollY = window.scrollY;

          if (currentScrollY > 80) {
            header.classList.add('header--scrolled');
          } else {
            header.classList.remove('header--scrolled');
          }

          if (currentScrollY > lastScrollY && currentScrollY > 200) {
            header.classList.add('header--hidden');
          } else {
            header.classList.remove('header--hidden');
          }

          lastScrollY = currentScrollY;
          ticking = false;
        });
        ticking = true;
      }
    });

    // Inject header scroll styles
    var headerStyle = document.createElement('style');
    headerStyle.textContent = [
      '.header--scrolled { box-shadow: 0 2px 24px rgba(26,26,26,0.18) !important; }',
      '.header--hidden { transform: translateY(-100%); transition: transform 350ms cubic-bezier(0.65,0,0.35,1); }',
      '.header { transition: transform 350ms cubic-bezier(0.16,1,0.3,1), box-shadow 350ms ease; }'
    ].join('\n');
    document.head.appendChild(headerStyle);
  }

  /* ── 3. MARQUEE PAUSE ON HOVER ────────────────────────────── */
  function initMarqueePause() {
    var bars = document.querySelectorAll('.social-proof-bar');
    bars.forEach(function (bar) {
      var track = bar.querySelector('.social-proof-bar__track');
      if (!track) return;
      bar.addEventListener('mouseenter', function () {
        track.style.animationPlayState = 'paused';
      });
      bar.addEventListener('mouseleave', function () {
        track.style.animationPlayState = 'running';
      });
    });
  }

  /* ── 4. PRODUCT IMAGE ZOOM ON HOVER ──────────────────────── */
  function initProductImageZoom() {
    var cards = document.querySelectorAll('.card__media');
    cards.forEach(function (card) {
      card.style.overflow = 'hidden';
    });
  }

  /* ── 5. ANNOUNCEMENT BAR AUTO-ROTATE ─────────────────────── */
  function initAnnouncementRotate() {
    var items = document.querySelectorAll('.announcement-bar__message');
    if (items.length <= 1) return;

    var current = 0;
    items.forEach(function (item, i) {
      item.style.display = i === 0 ? 'block' : 'none';
      item.style.transition = 'opacity 400ms ease';
    });

    setInterval(function () {
      items[current].style.opacity = '0';
      setTimeout(function () {
        items[current].style.display = 'none';
        current = (current + 1) % items.length;
        items[current].style.display = 'block';
        setTimeout(function () {
          items[current].style.opacity = '1';
        }, 20);
      }, 400);
    }, 4000);
  }

  /* ── 6. SMOOTH ADD-TO-CART FEEDBACK ────────────────────────
     Scoped 2026-08. This handler sets btn.textContent, which
     REPLACES every child node of the button. On the custom abaya
     product page the Add to Bag button contains a
     <span class="abaya-product__atc-text"> plus an inline SVG bag
     icon, so this wiped both — the icon never came back, and the
     span that abaya-product.js holds a reference to was detached,
     leaving that script writing into an orphaned node.

     abaya-product.js has its own feedback routine that updates
     only the inner span, so skip anything it owns and let this
     handle the stock Dawn buttons elsewhere on the site.
  ──────────────────────────────────────────────────────────── */
  function initCartFeedback() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches('[action*="/cart/add"]')) return;

      // Owned by abaya-product.js — don't double-handle.
      if (form.closest('.abaya-product')) return;

      var btn = form.querySelector('[type="submit"], .product-form__submit');
      if (!btn) return;
      if (btn.querySelector('.abaya-product__atc-text')) return;

      var originalText = btn.textContent.trim();
      btn.textContent = 'Adding…';
      btn.disabled = true;

      setTimeout(function () {
        btn.textContent = '✦ Added';
        btn.style.background = 'var(--color-deep-oud)';
        btn.style.borderColor = 'var(--color-deep-oud)';
        btn.style.color = 'var(--color-antique-ivory)';
      }, 400);

      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.style.background = '';
        btn.style.borderColor = '';
        btn.style.color = '';
      }, 2000);
    });
  }

  /* ── 7. WISHLIST BUTTON TOGGLE (Visual) ───────────────────── */
  function initWishlistToggle() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.wishlist-btn');
      if (!btn) return;
      btn.classList.toggle('is-wishlisted');
      btn.setAttribute(
        'aria-label',
        btn.classList.contains('is-wishlisted') ? 'Remove from wishlist' : 'Add to wishlist'
      );
    });

    var wishlistStyle = document.createElement('style');
    wishlistStyle.textContent = [
      '.wishlist-btn { background: none; border: none; cursor: pointer; color: var(--text-secondary); transition: color 200ms ease; }',
      '.wishlist-btn:hover { color: var(--color-desert-gold); }',
      '.wishlist-btn.is-wishlisted { color: var(--color-deep-oud); }'
    ].join('\n');
    document.head.appendChild(wishlistStyle);
  }

  /* ── 8. LAZY LOAD IMAGES ──────────────────────────────────── */
  function initLazyLoad() {
    if ('loading' in HTMLImageElement.prototype) return; // native support
    var images = document.querySelectorAll('img[loading="lazy"]');
    if (typeof IntersectionObserver === 'undefined') return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) img.src = img.dataset.src;
          io.unobserve(img);
        }
      });
    });

    images.forEach(function (img) { io.observe(img); });
  }

  /* ── 9. NEWSLETTER SUCCESS STATE ─────────────────────────── */
  function initNewsletterSuccess() {
    var forms = document.querySelectorAll('[id^="newsletter-form"]');
    forms.forEach(function (form) {
      // Check if Shopify returned success (page reloads with ?customer_posted=true)
      var params = new URLSearchParams(window.location.search);
      if (params.get('customer_posted') === 'true') {
        var input = form.querySelector('.email-signup__input');
        var btn = form.querySelector('button[type="submit"]');
        if (input) {
          input.value = 'Thank you for subscribing!';
          input.disabled = true;
        }
        if (btn) {
          btn.textContent = '✦ Subscribed';
          btn.disabled = true;
        }
      }
    });
  }

  /* ── 10. GOLD CURSOR TRAIL (Subtle, Desktop Only) ─────────── */
  function initGoldCursor() {
    if (window.matchMedia('(pointer: coarse)').matches) return; // skip touch
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var trail = document.createElement('div');
    trail.id = 'abaya-cursor-trail';
    trail.style.cssText = [
      'position: fixed;',
      'width: 6px;',
      'height: 6px;',
      'border-radius: 50%;',
      'background: var(--color-desert-gold);',
      'pointer-events: none;',
      'z-index: 9999;',
      'opacity: 0;',
      'transition: opacity 200ms ease, transform 80ms linear;',
      'transform: translate(-50%,-50%);',
      'mix-blend-mode: multiply;'
    ].join('');
    document.body.appendChild(trail);

    document.addEventListener('mousemove', function (e) {
      trail.style.left = e.clientX + 'px';
      trail.style.top = e.clientY + 'px';
      trail.style.opacity = '0.55';
    });

    document.addEventListener('mouseleave', function () {
      trail.style.opacity = '0';
    });
  }

  /* ── INIT ──────────────────────────────────────────────────── */
  function init() {
    initStickyHeader();
    initMarqueePause();
    initProductImageZoom();
    initAnnouncementRotate();
    initCartFeedback();
    initWishlistToggle();
    initLazyLoad();
    initNewsletterSuccess();
    initGoldCursor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on Shopify section reload (Theme Editor).
  // Scroll reveal is no longer re-run here — abaya-motion.js owns
  // that and scopes its re-scan to the section that actually
  // reloaded, instead of re-hiding revealed content page-wide.
  document.addEventListener('shopify:section:load', function () {
    initMarqueePause();
  });

})();
